export const defaultBuffer = {
   "children": [
      {
         "style": {

         },
         "id": "GroupInfo"
      },
      {
         "children": [
            {
               "style": {

               },
               "id": "Event"
            }
         ],
         "style": {

         },
         "id": "RootControl",
         "event": {
            "name": "Event",
            "Event": [
               {
                  "Events": [

                  ],
                  "name": "Events"
               }
            ]
         },
         "elem_type": "form"
      }
   ],
   "customControl": [
   ],
   "formName": "testForm",
   "ElementCount": {
      "paragraph": 1,
      "textbox": 1,
      "textarea": 1,
      "video": 1,
      "Step": 1,
      "radio": 1,
      "button": 1,
      "tab": 1,
      "SubStep": 1,
      "checkbox": 1,
      "sheet": 1,
      "iframe": 1,
      "map": 1,
      "table": 1,
      "EmptyRow": 1,
      "image": 1,
      "datepick": 1,
      "EmptyCell": 1,
      "combo": 1,
      "toggle": 1,
      "label": 1,
      "listbox": 1,
      "headerframe": 1,
      "CustomControl": 1,
      "imagecarousel": 1,
      "MainMenu": 1,
      "frame": 1
   },
   "theme": {
      "themeName": "Default Theme",
       "SpacingType": "Default Spacing",
       "Control Spacing": {
         "Spacing Left": '12',
         'Spacing Right': '12',
         'Spacing Top': '8',
         'Spacing Bottom': '8',
       },
      "PageStyle": {
         "backgroundColor": "#FFFFFF"
      },
      "ActiveStateStyle": {
         "ActiveStates": "#0072c6"
      },
      "SectionStyle": {
         "ControlStyle": "Style2",
         "AccordionColor": "#606060",
         // "HeaderBackColor": "#0072c6",
         "BorderColor": "#C4C4C4",
         "FontWeight": "Semibold",
         "FontColor": "#606060"
      },
      "InputStyle": {
         "ValueFontWeight": "Normal",
         "BorderRadius": "2px",
         "BorderColor": "#C4C4C4",
         "LabelFontWeight": "Semibold",
         "BorderWidth": "1px",
         "LabelValueAlignment": "Top Bottom",
         "ControlStyleTextbox": "Style1",
         "ControlStyleRadio": "Style1",
         "ControlStyleCheckbox": "Style1",
         "ControlStyleToggle": "Style1",
         // "DatepickerType": "Date",
         "DateTimeSeperator": "1",
         "DateSeperator": "1",
         "ThemeDateFormat": "1",
         "ThemeDateFormat2": "5",
         "ArabicLanguage": "Arabic",
         "LabelFontColor": "",
         "ValueFontFamily" : "Open Sans",
         "ValueFontSize" : "12px",
         "ValueFontColor" : "#000000"
         //  "EALanguage": "English"
      },
      "TabSheetStyle": {
         "TabSelectionsHeaderColor": "#168edd"
      },
      "ButtonStyle": {
         "ControlStyle": "Primary",
         "CornerRadius": "2px",
         "FontWeight": "Bold",
         "BackgroundColor": "#FFFFFF",
         'PrimaryButtonFontWeight': "600",
         'PrimaryButtonBorderRadius': "3px",

      },
      "LabelStyle": {
         "BackgroundColor": "#FFFFFF",
         "FontWeight": "Semibold",
         "LabelAlignment": "Left",
         "FontColor": "#606060"
      },
      "BasicTheme": {
         // "TabSelectionsHeaderColor":"#168edd",
         "ActiveTextColor": "",
         "HeaderBackColor": "#0072c6",
         "ActiveStates": "#0072c6",
         // "FontColor":"#0072C6",
         "FontColor": "#000000",
         "LabelFontColor":"#606060",
         "FontFamily": "Open Sans",
         "LabelFontWeight":"Semibold",
         "FontSize": "12px",
         "PrimaryColor": "#685AC0",
         "Spacing": "Regular",
         "TabSelectionsHeaderColor": "",
         'colorPallete': [
            { 'colorName': 'Black', 'colorCode': '#222222', 'backgroundColor': '#222222', borderRadius: '2px 0px 0px 2px', 'index': 0 },
            { 'colorName': 'Dark Grey', 'colorCode': '#4D4D4D', 'backgroundColor': '#4D4D4D', 'index': 1 },
            { 'colorName': 'Light Grey', 'colorCode': '#E0E0E0', 'backgroundColor': '#E0E0E0', 'index': 2 },
            { 'colorName': 'White', 'colorCode': '#FFFFFF', 'backgroundColor': '#FFFFFF', 'index': 3 },
            { 'colorName': 'Tint 2 of Primary', 'colorCode': '#685AC014', 'backgroundColor': '#685AC014', 'index': 4 },
            { 'colorName': 'Tint 1 of Primary', 'colorCode': '#685AC029', 'backgroundColor': '#685AC029', 'index': 5 },
            { 'colorName': 'Secondary', 'colorCode': '#AE2BC6', 'backgroundColor': '#AE2BC6', 'index': 6 },
            { 'colorName': 'Primary', 'colorCode': '#685AC0', 'backgroundColor': '#685AC0', borderRadius: '0px 2px 2px 0px', 'index': 7 }
         ],
      },
      "SliderTheme": {
         "SlideBarHeader": "#0072c6"
      },
      "HorizontalTabStyle": {
         BackColor: "#FFFFFF",
         ControlStyle: "Style1",
         IconLabelAlignment: "Left Right",
         contentBox: {
            minHeight: '',
            background: '#FFFFFF',
            border: {
               size: '2pt',
               color: '#C4C4C4',
            },
            borderRadius: '0px',
         },
         label: {
            active: {
               fontfamily: 'Open Sans',
               size: '12px',
               weight: '300',
               fontstyle: 'normal',
               color: '#0072C6',
               background: "#FFFFFF",
               borderRadius: "",
               margin: "",
               padding: "",
            },
            fontfamily: 'Open Sans',
            size: '12px',
            weight: '100',
            fontstyle: 'normal',
            color: '#0072C6',
            background: "#FFFFFF",
         },
         actionItemSaveNext: {
            color: '#FFFFFF',
            background: "#0072C6",
            fontSize: '12px',
            fontWeight: 'Normal',
            marginRight: "2px !important",
            marginLeft: "0.5rem !important",
            padding: "2px 10px !important",
            fontFamily: "Open Sans",
            border: "1px solid #0072C6",
            marginTop: "0 !important",
            marginBottom: "0 !important",
         },
         actionItemSave: {
            color: '#0072C6',
            background: "#FFFFFF",
            fontSize: '12px',
            fontWeight: 'Normal',
            marginLeft: "0.5rem !important",
            padding: "1px 10px !important",
            fontFamily: "Open Sans",
            border: "1px solid #0072C6",
            marginTop: "0 !important",
            marginBottom: "0 !important",
         },
         actionBar: {
            background: "#ffffff"
         },
         "Horizontal Spacing": "16",
         "Vertical Spacing":  "16",
         "Spacing Left": "16",
         "Spacing Right": "16",
         "Spacing Bottom": "16",
         "Spacing Top": "16",
         "ActiveTabFontWeight": "300",
         "InActiveTabFontWeight": "100",
         "BorderColor": "",
         "BorderWidth": "2px",
         "BorderRadius": "0px",
      },
      "TableStyle": {
         "TableColumnBackgroundColor": "#F8F8F8",
         "TableColumnFontWeight": "600",
         "TableColumnFontFamily": "Open Sans",
         "TableColumnFontSize": "12px",
         "TableRowFontWeight": "Bold",
         "TableRowBackgroundColor": "#FFFFFF",
         "ControlStyle": "Box",
         "TableTitleFontWeight": "Semibold",
         "TableColumnFontColor": "#606060",
         "TableRowFontFamily": "Open Sans",
         "TableRowFontSize": "12px",
         "TableRowFontColor": "#000000",
         "TableTSelectedRowColor": "transparent",
         "TableRowBorderColor": "#c4c4c4",
         "Hover Effect": "false"
      },
      "label": {
         "Visible": "true",
         "MobileVisible": "true",
         "TabsVisible": "true",
         "LabelAlignment": "",
         "FontFamily": "Open Sans",
         "FontSize": "12px",
         "FontWeight": "",
         "FontColor": "#000000",
         "BackColor": "#FFFFFF"
      },
      "link": {
         "Visible": "true",
         "Man": "true",
         "Enable": "true",
         "LinkAlignment": "",
         "FontFamily": "Open Sans",
         "FontSize": "12px",
         "OnClick": "URL",
         "FontWeight": "normal",
         "FontColor": "#3D6CE9",
         "BackColor": "#fff",
         "MobileVisible": "true",
         "TabsVisible": "true",
      },
      "doclist": {
         "DocTypeStyle": "Style1",
         "FontColor": "#0072C6",
         "Visible": "true",
         "Enable": "true",
         "BackgroundColor": "#FFFFFF",
         "CornerRadius": "2px",
         "MobileVisible": "true",
         "TabsVisible": "true",
         "FontStyle": "Normal",
         "DocumentTypeLabelFontColor": "#000000",
         "DocumentTypeLabelFontFamily": "Open Sans",
         DocumentTypeLabelFontWeight: "300",
         DocumentTypeLabelFontStyle: "Normal",
         "DocumentTypeLabelFontSize": "12px",
         DocumentListLabelFontColor: "#000000",
         DocumentListLabelFontFamily: "Open Sans",
         DocumentListLabelFontSize: "12px",
         DocumentListLabelFontWeight: "300",
         DocumentListLabelFontStyle: "Normal",
      },
      "DoclistStyle": {
         "DocTypeStyle": "Style1",
         "FontColor": "#0072C6",
         "Visible": "true",
         "Enable": "true",
         "BackgroundColor": "#FFFFFF",
         "CornerRadius": "2px",
         "MobileVisible": "true",
         "TabsVisible": "true",
         "FontStyle": "Normal",
         "DocumentTypeLabelFontColor": "#000000",
         "DocumentTypeLabelFontFamily": "Open Sans",
         DocumentTypeLabelFontWeight: "300",
         DocumentTypeLabelFontStyle: "Normal",
         "DocumentTypeLabelFontSize": "12px",
         DocumentListLabelFontColor: "#000000",
         DocumentListLabelFontFamily: "Open Sans",
         DocumentListLabelFontSize: "12px",
         DocumentListLabelFontWeight: "300",
         DocumentListLabelFontStyle: "Normal",
      }
   },
   "style": {
      "FontStyle": "1",
      "ImageFormUrl": "",
      "GradientColor1": "#transparent",
      "EnableSliderArrows": "false",
      "ImageAllignment": "Center",
      "CombinedFontWeight": "Bold",
      "GradientColor2": "#transparent",
      "SelectedCarouselImages": "",
      "HeaderAllignment": "center",
      "ScreenBackgroundImage": "",
      "FormMaxWidth": "",
      "FormWidthType": "1",
      "FontWeight": "2",
      "FormBorderWidth": "0px",
      "FormHorizontal": "false",
      "FormVertical": "center",
      "FormAllignments": "",
      "AllowAutoScroll": "false",
      "ShowHeader": "true",
      "GradientPercent1": "0",
      "GradientPercent2": "100",
      "BoderSize": "0",
      "FormWidth": "100",
      "TopPercent": "0",
      "height": "100%",
      "FontFamily": "2",
      "Breakpoint": {
         "Desktop": {
            "StartValue": "1000",
            "EndValue": "1250"
         },
         "Tab": {
            "StartValue": "750",
            "EndValue": "1000"
         },
         "Mobile": {
            "StartValue": "320",
            "EndValue": "750"
         }
      },
      "Breakpoints": [
         {
            "StartValue": "1000",
            "EndValue": "1250",
            "device": "Desktop"
         },
         {
            "StartValue": "750",
            "EndValue": "1000",
            "device": "Tab"
         },
         {
            "StartValue": "320",
            "EndValue": "750",
            "device": "Mobile"
         }
      ],
      "CurrentDevice": {

      },
      "ScreenBackgroundRadio": "bgcolor",
      "BackColor": "#ffffff",
      "BackColorBoundary": "#ffffff",
      "FontColor": "#000000",
      "GradientAngles": "",
      "LeftPercent": "0",
      "FormBackgroundColor": "#ffffff",
      "FitToContentHeight": "false",
      "FontSize": "18px",
      "FixHeader": "1",
      "FormMinWidth": "",
      "InputStyle": "",
      "FormBorderColor": "#d7d7d7",
      "CanvasWidth": 1230,
      "width": "100%",
      "ScreenBgImgWidth": "",
      "AddGradient": "false",
      "RightPercent": "0",
      "ScreenBackgroundColor": "#ffffff"
   },
   "ControlType": "form",
   "id": "FormDef",
   "controlSet": [

   ],
   "ZoneList": [

   ],
   "elem_type": "form",
   "keys": {
      "Root": [],
      "SubForm": [],
      "AdvListView": [],
   },
};